import { gql } from "@apollo/client";
// import { graphql } from "react-apollo";

import { 
    Transaction,
    // FindTransactions 
} from "../../../../schemaTypes";

export const findTransactionsQuery = gql`
  query FindTransactionsQuery {
    findTransactions{
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      offer{
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
          createdBy{
            id
            role
          }
          createdAt
          updatedAt
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        amount
        referralUrl
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community{
          id
          name
          alias
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy{
          id
          role
          admin {
            id
            shortId
            firstname
            lastname
            email
            phone
            merchantProfile {
              id
              businessName
              businessType
              regCountry
              businessRegNumber
              taxId
              address
              addressAlt
              city
              country
              postcode
              companyName
              username
              category {
                id
                name
                imgSrc
                createdBy{
                  id
                  role
                }
                createdAt
                updatedAt
              }
              companyLocation
              logoUrl
              bannerUrl
              description
              commissionRate
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      njoyCode
      partnerVoucher
      user {
        id
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const newTransactionSubscription = gql`
  subscription NewTransactionSubscription {
    newTransaction {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      offer{
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
          createdBy{
            id
            role
          }
          createdAt
          updatedAt
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        referralUrl
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community{
          id
          name
          alias
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy{
          id
          role
          admin {
            id
            shortId
            firstname
            lastname
            email
            phone
            merchantProfile {
              id
              businessName
              businessType
              regCountry
              businessRegNumber
              taxId
              address
              addressAlt
              city
              country
              postcode
              companyName
              username
              category {
                id
                name
                imgSrc
                createdBy{
                  id
                  role
                }
                createdAt
                updatedAt
              }
              companyLocation
              logoUrl
              bannerUrl
              description
              commissionRate
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      njoyCode
      partnerVoucher
      user {
        id
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export interface WithFindTransactions {
  transactions: Transaction[];
  loading: boolean;
  subscribe: () => () => void;
}

// export const withFindTransactions = graphql<
//   any,
//   FindTransactionsQuery,
//   {},
//   WithFindTransactions
// >(findTransactionsQuery, {
//   props: ({ data }) => {
//     let transactions: Transaction[] = [];

//     if (data && !data.loading && data.findTransactions && typeof data.subscribeToMore === "function") {
//       transactions = data.findTransactions;
//     }

//     return {
//       transactions,
//       loading: data ? data.loading : false,
//       subscribe: () =>
//         data!.subscribeToMore({
//           document: newTransactionSubscription,
//           updateQuery: (prev, { subscriptionData }) => {
//             if (!subscriptionData.data) {
//               return prev;
//             }

//             // update prev with new data
//             return {
//               ...prev,
//               findTransactions: [
//                 ...prev.findTransactions,
//                 (subscriptionData.data as any).newTransaction
//               ]
//             };
//           }
//         })
//     };
//   }
// });